/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AllergenEnum {
  Milk = 'Milk',
  Corn = 'Corn',
  Egg = 'Egg',
  Fish = 'Fish',
  Sulphites = 'Sulphites',
  Nuts = 'Nuts',
  Crustaceans = 'Crustaceans',
  Molluscs = 'Molluscs',
  Celery = 'Celery',
  Soy = 'Soy',
  Peanuts = 'Peanuts',
  Mustard = 'Mustard',
  Sesame = 'Sesame',
  Lupine = 'Lupine',
}
